export default __webpack_public_path__ + "static/media/qrates_replica.e00621e4.png";